const routes = {
  root: "/",
  entity: "/:entityType(facility|department)/:entityId",
  overview: "/:entityType(facility|department)/:entityId/overview",
  roundingMonitor:
    "/:entityType(facility)/:parentEntityId/:entityType(unit)/:entityId/roundingMonitor",
  roundingMonitorNested:
    "/:entityType(facility)/:parentEntityId/:entityType(department)/:entityId/:entityType(unit)/:entityId/roundingMonitor",
  detail:
    "/:entityType(facility|department)/:entityId/:childEntityType(departments|units|roles|staff|rooms)",
  entityDetail:
    "/:parentEntityType(facility|department)/:parentEntityId/:entityType(staff|room)/:entityId",
  nestedEntityOverview:
    "/:parentEntityType(facility|department)/:parentEntityId/:entityType(department|unit)/:entityId/overview",
  nestedEntityDetail:
    "/:parentEntityType(facility|department)/:parentEntityId/:entityType(department|unit|role|staff|room)/:entityId/:childEntityType(staff|roles|units|rooms)",
  support: "/support",
  error: "/error",
  login: "/login",
}

export default routes
